<template>
    <div class="columns is-multiline is-centered">
        <div class="column is-one-half-tablet is-one-third-desktop" v-for="(project, index) in cardData" :key="project.title">
            <div class="box box-shadow-lift">
                <div class="card-content">
                    <div class="card-image">
                        <figure class="image is-4by3">
                            <img :src=project.photo :alt=project.alt>
                        </figure>
                    </div>
                    <div class="media" style="border-top: none">
                        <div class="media-content has-text-centered" style="margin: 0.9rem 0">
                            <h4 class="title is-4" :id="project.id">{{ project.title }}</h4>
                            <p class="subtitle has-text-grey is-6">{{ project.subtitle }}</p>
                        </div>
                    </div>
                    <div class="content has-text-left">
                        <p>{{ project.summary }}</p>
                        <div class="tags">
                            <div class="tag" v-for="tag in project.tags" :key="tag">
                                {{ tag }}
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="columns">
                    <div class="column is-half">
                        <a :href="project.source" :aria-label="project.ariaSource" class="button is-fullwidth" target="_blank" rel="noreferrer">View Source</a>
                    </div>
                    <div class="column is-half">
                        <a href="#" :id="project.demo" :aria-labelledby="project.ariaDemo" ref="demoBtn" class="button is-fullwidth" @click="toggleModal();setIndex(index)">Demo</a>
                    </div>
                </div>
            </div>
        </div>
    <DemoModal :isOpen="isOpen" :i="modalIndex" v-on:close-modal="toggleModal"></DemoModal>
    </div>
</template>

<script>
import cardInfo from '@/models/mainProjects'
import DemoModal from '@/components/MainDemoModal'

export default {
    components: {
        DemoModal
    },
    data: () => ({
        cardData: cardInfo.mainProjects,
        isOpen: false,
        modalIndex: 0
    }),
    methods: {
        toggleModal () {
            this.isOpen =! this.isOpen;
            // modalIndex resets the focus of the correct card when returning from modal
            if(this.isOpen == false) {
                this.$nextTick(() => {
                    const newFocus = this.$refs.demoBtn;
                    newFocus[this.modalIndex].focus();
                })
            }

        },
        setIndex (indexCard) {
            this.modalIndex = indexCard;
        }
    }
}
</script>

<style>

</style>